import { Result } from "@/main/models/common/resultResponse";
import { CompanyPreferencesResponse } from "@/main/models/response";
import { AxiosResponse } from "axios";

export abstract class ICompanyPreferenceApi {
	abstract GetCompanyPreferencesByLoggedUser(): Promise<AxiosResponse<Result<CompanyPreferencesResponse>>>;
}
